import { trimReduce } from './array-trim-reduce';

/**
 * split given string and trim parts.
 * remove all empty strings from array.
 */
export function splitTrim(str: string, pattern: string | RegExp = ',', limit?: number): string[] {
  return trimReduce(str.split(pattern, limit));
}
